<prlw-text-marquee-ui [items]="items$ | async"></prlw-text-marquee-ui>
